import React, {Component,PropTypes} from 'react'




class Sliderlabels extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value,
    };
    this.handleChange=this.handleChange.bind(this);
   
  }

  handleChange(event) {

    this.setState({value: event.target.value});
    console.log(event.target.value);
    this.props.updateAction(this.props.theKey,event.target.value);
  }

 
getsize(tamany){


 
  var size; 

  switch (tamany) {

    case "1":
      size = "xxxsmall";
      break;
    case "2":
      size = "xxsmall";
      break;
    case "3":
       size = "xsmall";
      break;
    case "4":
      size = "small";
      break;
    case "5":
      size = "normal";
      break;
    case "6":
      size = "large";
      break;
    case "7":
      size = "xlarge";
      break;
    case "8":
      size = "xxlarge";
      break;
    case "9":
      size = "xxxlarge";
      break;
  }

 

    return size;

   
}





  render() {

          
         
             
        return (


            <div className="form-group label-floating is-empty">
             
                 <div className="slidecontainer">
                       
                       
                          <label className="pull-left">Pequeño</label>
                          <label text-align="center"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Tamaño : {this.getsize(this.state.value)} </label>
                          <label  className="pull-right">Grande</label>
                          <input type="range" min="1" max="9" step="1" className="slidercode" value={this.state.value} onChange={this.handleChange}   />
                            
                           
                 
                              

                  </div>
  
            
             </div>
     
     
      )


  } 
}
export default Sliderlabels;

Sliderlabels.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/fields/Sliderlabels.js